<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kdMyQC/tc-custom/9781614233329.jpg?1688954038921" alt="This image is the cover for the book Battle of Mine Creek: The Crushing End of the Missouri Campaign, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle of Mine Creek: The Crushing End of the Missouri Campaign, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1864, Union troops controlled much of the South, Sherman's men marched with impunity through Georgia and defeat at Gettysburg was a painful and distant memory. The Confederacy needed to stem the tide. Confederate major general Sterling Price led an army of twelve thousand troops on a desperate charge through Missouri to deliver the state to the Confederacy and dash President Lincoln's hopes for reelection. This daring campaign culminated with the Battle of Mine Creek. A severely outnumbered Union army crushed the Confederate forces in one of the war's largest and most audacious cavalry charges. Historian<br/>Jeff Stalnaker puts the reader in the saddle with the Union troopers as they destroy all hope for Rebel victory in the Trans-Mississippi.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey D. Stalnaker
      </h2>
      
      <p class="authorDescription body article">Jeff Stalnaker lives in Mission, Kansas, with his wife, Jen, his daughter, Emma, and two dogs and a cat. He has a degree from the University of Kansas, with an emphasis in history and political science, is an avid student of history and is a local Kansas City singer/songwriter. He is also a World War II living historian, reenacting both the U.S. Army and British army.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d376545